// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('contacts.timestampingusers', {
        url: '/timestampingusers',
        views: {
            "contactList@contacts": {
                templateUrl: 'main/timestamp/timestampingusers/timestampingusers.tpl.html',
                controller: 'TimeStampingUsersController as vm'
            }
        },
        resolve: {
            users: usersResolver
        }
    });
}

// @ngInject
function usersResolver(TimeStampingApiService) {
    return TimeStampingApiService.getTimeStampingUsers();
}

// @ngInject
function TimeStampingUsersController($scope, $state, users) {
    var vm = this;

    vm.userList = users.data;
    vm.selectedUserId = 0;
    vm.selectUser = selectUser;

    console.log("TimeStampingUsers:");
    console.log(users.data);

    activate();

    function activate() {
        $scope.$watch(function() { return $state.params.userId; }, function(newValue, oldValue) {
            vm.selectedUserId = parseInt($state.params.userId, 10);
        });
    }

    function selectUser(user) {
        $state.go('contacts.timestampingusers.timestamping', {userId: user.id});
    }

    function generateUserList(users) {
        var list = [];

        _.forEach(users,function(user) {
            var userCopy = _.clone(user);
            list.push(userCopy);
        });

        return _.sortBy(list, ['firstName']);
    }

}

angular.module('timestamp.timestampingusers', [])
    .config(stateConfig)
    .controller('TimeStampingUsersController', TimeStampingUsersController);
